import { useExportQuotaQuery } from "../queries/useExportQuotaQuery";
import type { QuotaOperationState, ExportQuotaState } from "../types";

const DEFAULT_EXCEL_QUOTA: QuotaOperationState = { used: 0, remaining: 0, total: 0 };

type HookValue = ExportQuotaState & { isLoading: boolean; isFetched: boolean };

export const useExportQuota = (enabled?: boolean): HookValue => {
    const { data: rawData, isFetching, isFetched } = useExportQuotaQuery(enabled);
    const data = rawData ?? DEFAULT_EXCEL_QUOTA;

    return {
        data,
        isLoading: isFetching,
        isFetched,
        isQuotaReached: data.remaining === 0,
        isQuotaAllowed: data.total > 0,
    };
};
